class FacetFiltersForm extends HTMLElement {
  constructor() {
    try {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);

      const facetForm = this.querySelector('form');
      const mobileSortBy = document.querySelector('#SortBy-mobile');

      if(facetForm){
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      }
      if(mobileSortBy){
        mobileSortBy.addEventListener('change', this.debouncedOnSubmit.bind(this));
      }

      window.addEventListener('resize', FacetFiltersForm.adjustSortByLabel);

    } catch (error) {
      console.error(error);
    }
  }

  static convertImageToDivWhenNoImage() {
    document.querySelectorAll('.facet-image').forEach(swatch => {
      swatch.onerror = () => {
        swatch.onerror = null;
        const divReplacement = document.createElement('div');
        const title = swatch.getAttribute('title'); 

        divReplacement.className = 'facet-image background-boden-light-grey';
        if (title) divReplacement.setAttribute('title', title); 

        swatch.parentNode.replaceChild(divReplacement, swatch);
      };
    });
  }

  static adjustSortByLabel() {
    const select = document.querySelector('#SortBy-mobile');
    if (!select) return;

    const container = select.closest('.mobile-facets__sort');
    const customLabel = container?.querySelector('.mobile-facets__summary-label');
    const selectedOption = select.options[select.selectedIndex];
    if (!customLabel || !selectedOption) return;

    const originalText = selectedOption.textContent.trim();
    const prefix = customLabel.dataset.label?.trim() || '';
    const fullText = `${prefix} ${originalText}`;

    // Reset content and styles
    customLabel.textContent = fullText;
    container.style.width = '';
    select.style.width = '';

    // Desktop: Adjust width
    if (window.innerWidth >= 1024) {
      requestAnimationFrame(() => {
        const paddedWidth = customLabel.scrollWidth + 48; // padding: 16 + 32
        container.style.width = `${paddedWidth}px`;
        select.style.width = '100%';
      });
    }

    // Mobile: Truncate if needed
    if (window.innerWidth < 1024) {
      const paddingOffset = 48;
      const availableWidth = container.offsetWidth - paddingOffset;

      if (customLabel.scrollWidth > availableWidth) {
        for (let i = originalText.length; i > 0; i--) {
          const attempt = `${prefix} ${originalText.slice(0, i)}...`;
          customLabel.textContent = attempt;
          if (customLabel.scrollWidth <= availableWidth) break;
        }
      }
    }
  }

  static onlyOpenOneDetailElementOnMobileAtATime() {
    try {
      const details = document.querySelectorAll('#FacetFiltersFormMobile details');
      if (!details) {
        throw new Error('Details not found');
      }
      details.forEach((targetMenu) => {
        targetMenu.addEventListener('click', () => {
          details.forEach((menu) => {
            if (menu !== targetMenu) {
              menu.removeAttribute('open');
            }
          });
        });
      });
    } catch (error) {
      console.error(error);
    }
  }

  static showClearAllButton() {
    try {
      const facetCheckboxes = document.querySelectorAll('#FacetFiltersFormMobile .mobile-facets__checkbox');

      // You have more than one now, so select ALL of them
      const clearAllButtons = document.querySelectorAll('#FacetFiltersFormMobile facet-remove.mobile-facets__clear-wrapper');

      if (!clearAllButtons.length) {
        throw new Error('Clear all buttons not found');
      }

      const toggle = () => {
        const checkedCount = document.querySelectorAll('#FacetFiltersFormMobile input:checked').length;
        clearAllButtons.forEach((btn) => {
          btn.classList.toggle('hidden', checkedCount < 1);
        });
      };

      // Initial state
      toggle();

      // Update on change
      facetCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', toggle);
      });
    } catch (error) {
      console.error(error);
    }
  }

  static renderQuickLinks(html) {
    const current = document.getElementById('QuickLinksContainer');
    if (!current) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = parsed.getElementById('QuickLinksContainer');
    if (!incoming) return;

    current.innerHTML = incoming.innerHTML;
  }

  static initQuickLinksAsFacets() {
    try {
      // bind once
      if (FacetFiltersForm._quickLinksDelegated) return;
      FacetFiltersForm._quickLinksDelegated = true;

      document.addEventListener('click', (event) => {
        const link = event.target.closest('.js-facet-quick-link');
        if (!link) return;

        const href = link.getAttribute('href');
        if (!href) return;

        event.preventDefault();

        const url = new URL(href, window.location.origin);
        const searchParams = url.search.startsWith('?') ? url.search.slice(1) : url.search;

        FacetFiltersForm.renderPage(searchParams, { target: link, srcElement: link });
      });
    } catch (error) {
      console.error(error);
    }
  }

  static renderSelectedFacetText() {
    const facetDetailsElements = document.querySelectorAll('#FacetFiltersFormMobile .js-filter');
    const sizeFacetDetailsElements = document.querySelectorAll('#FacetFiltersFormMobile .js-size-filter');

    /**
     * Clears the text if no facets are selected.
     */
    const clearSelectedTextIfNone = (detailElement, selectedFacetsArray) => {
      const selectedElement = detailElement.querySelector('.mobile-facets__selected');
      if (selectedElement && selectedFacetsArray.length === 0) {
        selectedElement.innerHTML = '';
      }
    };
  
    facetDetailsElements.forEach((detailElement, i) => {
      const selectedFacetsArray = [];

      detailElement.querySelectorAll('input').forEach((input) => {
        // Check if the facet is selected
        if (input.checked) {
          const selectedElement = input.closest('.js-filter').querySelector('.mobile-facets__selected');

          if(input.name?.includes("availability")) {
            // Push the dataset custom value for availability filter instead of value which in this case was 0 for Out of stock and 1 for In Stock.
            selectedFacetsArray.push(input.dataset.customValue);
          }
          else {
            // Push the selected facets into the selected assets array
            selectedFacetsArray.push(input.value);
          }
          // Format Array to display in the DOM
          const selectedFacetArrayString = selectedFacetsArray.join(', ');
          // Add the selected facet text to the new element
          if (selectedElement) {
            selectedElement.innerHTML = selectedFacetArrayString;
          }
        }
      });

      // Clear the text if no facets are selected
      clearSelectedTextIfNone(detailElement, selectedFacetsArray);
    });
    const allSelectedSizeValues = [];
    sizeFacetDetailsElements.forEach((detailElement) => {
      detailElement.querySelectorAll('input:checked').forEach((input) => {
        allSelectedSizeValues.push(input.value);
      });
    });

    const firstSizeGroup = sizeFacetDetailsElements[0];
    if (firstSizeGroup) {
      const selectedElement = firstSizeGroup.closest('.js-size-filter-wrapper')?.querySelector('summary .mobile-facets__selected');
      if (selectedElement) {
        selectedElement.textContent = allSelectedSizeValues.join(', ');
      }
    }
  }

  static updateSelectedFacetTextOnLoad() {
    FacetFiltersForm.renderSelectedFacetText();
  }

  static updateSelectedFacetTextOnInputChange() {
    const facetCheckboxes = document.querySelectorAll('#FacetFiltersFormMobile .mobile-facets__checkbox');
    facetCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (e) => {
        FacetFiltersForm.renderSelectedFacetText();
      });
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    try {
      let availabilitySearchParams = "";
      let availabilityFilter = 'filter.v.availability=1';
      let isSizeFilterClicked = false;

      if (event && event.srcElement && event.srcElement.dataset) {
        isSizeFilterClicked = event.srcElement.dataset.parentFilter === "size";
      }

      // Remove any existing availability filter
      const cleanParams = searchParams.replace(new RegExp(`(&|\\b)${availabilityFilter}(&|\\b)`, 'g'), (match, p1, p2) => {
        if (p1 === '&' && p2 === '&') return '&'; // Preserve a single '&' if surrounded by '&'
        return ''; // Otherwise, remove the match
      });

      // Check if any size filter is still active
      const hasSizeFilter = 
        searchParams.includes('filter.v.m.mechanic.size_type_') ||
        searchParams.includes('filter.v.option.fit=');

      // Decide final params
      if (hasSizeFilter) {
        availabilitySearchParams = availabilityFilter;
        if (cleanParams) {
          availabilitySearchParams += '&' + cleanParams;
        }
      } else {
        availabilitySearchParams = cleanParams;
      }

      FacetFiltersForm.searchParamsPrev = availabilitySearchParams;

      const sections = FacetFiltersForm.getSections();
      if (!sections || !Array.isArray(sections)) {
        throw new Error('Sections are not valid or are missing.');
      }

      const countContainer = document.getElementById('ProductCount');
      const productGridContainer = document.getElementById('ProductGridContainer');
      if (!productGridContainer) {
        throw new Error('ProductGridContainer element is missing.');
      }

      productGridContainer.querySelector('.collection').classList.add('loading');
      if (countContainer) {
        countContainer.classList.add('loading');
      }

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${availabilitySearchParams}`;
        const filterDataUrl = element => element.url === url;

        if (FacetFiltersForm.filterData.some(filterDataUrl)) {
          FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, availabilitySearchParams);
        } else {
          FacetFiltersForm.renderSectionFromFetch(url, event, availabilitySearchParams);
        }
      });

      if (updateURLHash) {
        FacetFiltersForm.updateURLHash(availabilitySearchParams);
      }
    } catch (error) {
      console.error('Error rendering the page:', error);
    }
  }

  static renderSectionFromFetch(url, event) {

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((responseText) => {

        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];

        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderProductButtonCount(html);
        FacetFiltersForm.renderQuickLinks(html);
        FacetFiltersForm.renderDataLayer(html, event); 
      })
      .catch((error) => {
        console.error('Error fetching section:', error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderProductButtonCount(html);
    FacetFiltersForm.renderQuickLinks(html);
    FacetFiltersForm.renderDataLayer(html, event); 
  }

  static renderProductGridContainer(html) {
    const productGrid = document.getElementById('ProductGridContainer');
    const newContent = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');

    if (productGrid && newContent) {
      productGrid.innerHTML = newContent.innerHTML;

      // Re-run Swym bindings after DOM update
      if (window.addEventListeners && typeof window.addEventListeners === 'function') {
        window.addEventListeners();
      } else {
        console.warn('Swym addEventListeners not available yet');
      }
    }
  }

  static renderDataLayer(html, event) {
    const productGridJSON = new DOMParser().parseFromString(html, 'text/html').querySelector('.datalayer-product-grid-json');
    const productGridDataText = productGridJSON ? productGridJSON.textContent || productGridJSON.innerHTML : null;

    window.dataLayer = window.dataLayer || [];

    if (productGridDataText) {
      try {
        const data = JSON.parse(productGridDataText);

        if (event && event.target) {
          if (event.target.classList.contains('facet-filters__sort')) {
            window.dataLayer.push({
              event: "load.manual.apply.sort",
              ...data,
            });
          }
        
          if (event.target.type === 'checkbox' && event.target.closest('.facet-checkbox')) {
            window.dataLayer.push({
              event: "load.manual.apply.filter",
              ...data,
            });
          }

        } else {

          // NOT SURE HOW TO GET REMOVE FILTER AS EVENT ALWAYS UNDEFINED
          window.dataLayer.push({
            event: "load.manual.remove.filter",
            ...data,
          });
        }

      } catch (error) {
        console.error('Error parsing product grid data:', error);
      }
    }
  }

  static renderProductButtonCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountButton').innerHTML;
    const productCountButton = document.getElementById('ProductCountButton');
    if (productCountButton) {
      productCountButton.innerHTML = count;
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
    const container = document.getElementById('ProductCount');

    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
  }

  static renderCounts(source, target) {
    if (!source || !target) return;

    const sourceSelected = source.querySelector('.facets__selected');
    const targetSelected = target.querySelector('.facets__selected');

    const sourceSummary = source.querySelector('.facets__summary');
    const targetSummary = target.querySelector('.facets__summary');

    if (sourceSelected && targetSelected) {
      targetSelected.outerHTML = sourceSelected.outerHTML;
    }

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersFormMobile .js-filter'
    );

    const sizeFacetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersFormMobile .js-size-filter'
    );
    const sizeFacetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersFormMobile .js-size-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    // Remove facets that are no longer returned from the server
    Array.from(sizeFacetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(sizeFacetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });
    
    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const sizeMatchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-size-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    const sizeFacetsToRender = Array.from(sizeFacetDetailsElementsFromFetch).filter((element) => !sizeMatchesId(element));
    const sizeCountsToRender = Array.from(sizeFacetDetailsElementsFromFetch).find(sizeMatchesId);

    sizeFacetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);

      // Step 1: Check if the element is already rendered in the DOM
      if (currentElement) {
        // If the element exists, update its innerHTML content
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        // Step 2: If the element is not already in the DOM, determine where to insert it
    
        // Check if there's a previous element in the array with the same class name
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = sizeFacetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            // If the current element shares the same class as the previous, insert it after
            document.getElementById(previousElementId).after(elementToRender);
            return; // Exit early after inserting
          }
        }
    
        // Step 3: Handle cases where the element needs to be inserted based on the parent and its order
        if (elementToRender.parentElement) {
    
          // Get the parent container of the current element
          const parentElement = document.getElementById(elementToRender.parentElement.id);
    
          // Find the correct position to insert the element by comparing `data-forloop-index`
          const referenceElement = Array.from(parentElement.children).find((child) => {
            // Extract the `data-forloop-index` of the current child
            const childIndex = parseInt(child.getAttribute('data-forloop-index'), 10); // Parse as base-10
            // Extract the `data-forloop-index` of the element to render
            const elementIndex = parseInt(elementToRender.getAttribute('data-forloop-index'), 10);
            // Return the first child whose index is greater than the element's index
            return childIndex > elementIndex;
          });
    
          // Step 4: Insert the element in the correct position
          if (referenceElement) {
            // If a reference element is found, insert the current element before it
            referenceElement.before(elementToRender);
          } else {
            // If no reference element is found (i.e., the current element has the highest index),
            // append the element to the end of the parent container
            parentElement.appendChild(elementToRender);
          }
        }
      }
    });

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);

      // Step 1: Check if the element is already rendered in the DOM
      if (currentElement) {
        // If the element exists, update its innerHTML content to reflect any changes
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        // Step 2: Handle insertion for similar facet types (e.g., horizontal/vertical, drawer/mobile)
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];

          // If the current element shares the same class as the previous one, insert it after the previous
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return; // Exit early after inserting
          }
        }
    
        // Step 3: Handle insertion based on parent element and data-index ordering
        if (elementToRender.parentElement) {
          // Get the parent container for the current element
          const parentElement = document.getElementById(elementToRender.parentElement.id);

          if (parentElement) {
            // Find the correct position to insert based on `data-index`
            const referenceElement = Array.from(parentElement.querySelectorAll('.js-filter, .js-size-filter-wrapper')).find((child) => {
              // Parse `data-index` from both child and the element to render
              const childIndex = parseInt(child.getAttribute('data-index'), 10); // Child's index
              const elementIndex = parseInt(elementToRender.getAttribute('data-index'), 10); // Current element's index
              return childIndex > elementIndex; // Find the first child with a higher index
            });
    
            if (referenceElement) {
              // If a reference element is found, insert the current element before it
              referenceElement.before(elementToRender);
            } else {
              // Get all elements that match either .js-filter or .js-size-filter-wrapper
              const allFilterElements = Array.from(parentElement.querySelectorAll('.js-filter, .js-size-filter-wrapper'));

              // If there are any matching elements, append after the last one
              if (allFilterElements.length > 0) {
                const lastFilterElement = allFilterElements[allFilterElements.length - 1];
                lastFilterElement.after(elementToRender);
              }
            }
          }
        }
      }
    });

    let newFilters = document.querySelectorAll('#FacetFiltersFormMobile .js-filter, #FacetFiltersFormMobile .js-size-filter');

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.updateSelectedFacetTextOnInputChange();
    FacetFiltersForm.hideEmptyMobileFilters(newFilters);
    FacetFiltersForm.hideHeadingIfAllLabelsDisabled();
    FacetFiltersForm.updateSelectedFacetTextOnLoad();
    FacetFiltersForm.showClearAllButton();
    FacetFiltersForm.initShowFacetRemove();
    FacetFiltersForm.adjustSortByLabel();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    if (sizeCountsToRender) FacetFiltersForm.renderCounts(sizeCountsToRender, event.target.closest('.js-size-filter'));
  }

  static hideEmptyMobileFilters(allFilters) {

    for (const filter of allFilters) {

      if (filter.getAttribute('data-filter-label') === 'Size') {
        return;
      }

      const labelsSelector = '.mobile-facets__label';
      const allLabelsDisabled = [...filter.querySelectorAll(labelsSelector)].every((label) => {

        return label.classList.contains('mobile-facets__label--disabled');
      });
      const summarySelector = '.mobile-facets__summary';
      const summary = filter.querySelector(summarySelector);

      if (!summary) return

      if (allLabelsDisabled && summary) {
        summary.style.display = 'none';
      }
      
    }

  }


  static hideHeadingIfAllLabelsDisabled() {

    const headings = document.querySelectorAll('.facets-group__heading');
    headings.forEach(heading => {
      const block = heading.closest('div.facets-group__block');
      const list = heading.closest('div.facets-group__block').querySelector('.facets__list');

      if(list){
        const labels = list.querySelectorAll('.facet-checkbox');
        const allLabelsDisabled = Array.from(labels).every((label) => {
          return label.classList.contains('facet-checkbox--disabled')
        });

        if (allLabelsDisabled) {
          heading.closest('div.facets-group__block').classList.add('hidden');
        }
      }
      else {
        block.classList.add('hidden');
      }
    });
  }

  static renderActiveFacets(html) {

    const activeFacetElementSelectors = ['.active-facets-mobile'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.convertImageToDivWhenNoImage();

  }

  static initShowFacetRemove() {
    this.initMobileFacetRemoveButton();
  }

  static initMobileFacetRemoveButton() {
    const targetElement = document.querySelector('menu-drawer details.mobile-facets__disclosure');
    let _allFacets = document.querySelectorAll('#FacetFiltersFormMobile .js-filter');
    let _allSizeFacets = document.querySelectorAll('#FacetFiltersFormMobile .facets__disclosure-size');

    if (targetElement.hasAttribute('open')) {
      _allFacets.forEach((element) => {
        this.showFacetRemoveButton(element, true);
      });
      _allSizeFacets.forEach((element) => {
        this.showFacetRemoveButton(element, true);
      });
    }

    const mutationObserver = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (targetElement.hasAttribute('open')) {
            _allFacets.forEach((element) => {
              this.showFacetRemoveButton(element, true);
            });
            _allSizeFacets.forEach((element) => {
              this.showFacetRemoveButton(element, true);
            });
          }
        }
      }
    });

    mutationObserver.observe(targetElement, {
      attributes: true
    });
  }

  static showFacetRemoveButton(facetHTML, isMobileDrawer = false) {
    let allInputs = isMobileDrawer ? facetHTML.querySelectorAll('li label.mobile-facets__label input') : facetHTML.querySelectorAll('fieldset .facet-checkbox input');
    let checkedInputs = Array.from(allInputs).filter(input => input.checked);
    let catFacet = facetHTML.querySelector('facet-remove');

    if (catFacet) {
      this.setClearSizeURL(catFacet, isMobileDrawer);
      if (checkedInputs.length > 0) {
        catFacet.classList.remove('hidden');
        catFacet.closest('details').querySelector('summary').classList.add('facets__summary--active');
        catFacet.closest('details').querySelector('summary').classList.remove('facets__summary--not-active');
      } else {
        catFacet.classList.add('hidden');
        catFacet.closest('details').querySelector('summary').classList.remove('facets__summary--active');
        catFacet.closest('details').querySelector('summary').classList.add('facets__summary--not-active');
      }
    }

  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [{
      section: document.getElementById('product-grid').dataset.id,
    }]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    try {
      event.preventDefault();
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');

      if (event.srcElement.className == 'mobile-facets__checkbox') {
        const searchParams = this.createSearchParams(event.target.closest('form'))
        this.onSubmitForm(searchParams, event)
      } else {
        const forms = [];
        const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetSortForm' || form.id === 'FacetSortDrawerForm') {
              const noJsElements = document.querySelectorAll('.no-js-list');
              noJsElements.forEach((el) => el.remove());
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersFormMobile') {
            const searchParams = this.createSearchParams(form);
            if (searchParams && Object.keys(searchParams).length > 0) {
              forms.push(searchParams);
            }
          }
        });
        this.onSubmitForm(forms.join('&'), event)
      }
    } catch (error) {
      console.error(error);
    }
  }
  
  static setClearSizeURL(facetEl, isMobileDrawer) {
    if (facetEl.hasAttribute('is-size-filter')) {
      let allCheckedInputs = isMobileDrawer ? facetEl.closest('.mobile-facets__submenu').querySelectorAll('input:checked') : facetEl.previousElementSibling.querySelectorAll('input:checked');

      // Create a URLSearchParams object to manipulate query parameters
      let urlParams = new URLSearchParams(window.location.search);

      // Always remove 'filter.v.availability=1'
      urlParams.delete('filter.v.availability');

      // Remove selected size filter(s)
      allCheckedInputs.forEach(input => {
        const inputName = input.getAttribute('name');
        if (inputName) {
          urlParams.delete(inputName);
        }
      });

      // Construct the cleaned URL
      let newQueryString = urlParams.toString();
      let newURL = window.location.pathname + (newQueryString ? '?' + newQueryString : '');

      // Update the "clear size" link
      facetEl.querySelector('a').setAttribute('href', newURL);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

FacetFiltersForm.updateSelectedFacetTextOnLoad();
FacetFiltersForm.updateSelectedFacetTextOnInputChange();
FacetFiltersForm.showClearAllButton();
FacetFiltersForm.hideHeadingIfAllLabelsDisabled();
FacetFiltersForm.initShowFacetRemove();
FacetFiltersForm.onlyOpenOneDetailElementOnMobileAtATime();
FacetFiltersForm.convertImageToDivWhenNoImage();
FacetFiltersForm.adjustSortByLabel();
FacetFiltersForm.initQuickLinksAsFacets();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

